var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"width":"100% !important","height":"1000px"},attrs:{"id":"idTramite","src":_vm.cUrlTramite}})])}
var staticRenderFns = []

export { render, staticRenderFns }